import { render, staticRenderFns } from "./TableSector.vue?vue&type=template&id=4d65bc92&scoped=true&"
import script from "./TableSector.vue?vue&type=script&lang=js&"
export * from "./TableSector.vue?vue&type=script&lang=js&"
import style0 from "./TableSector.vue?vue&type=style&index=0&id=4d65bc92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d65bc92",
  null
  
)

export default component.exports